export default {
  sum: v => _.sum(v),
  average: v => _.mean(v),
  count: v => v.length,
  min: v => _.min(v),
  max: v => _.max(v),
  null: () => null
};
